import { render, staticRenderFns } from "./NewPermission.vue?vue&type=template&id=879648e8&scoped=true&"
import script from "./NewPermission.vue?vue&type=script&lang=js&"
export * from "./NewPermission.vue?vue&type=script&lang=js&"
import style0 from "./NewPermission.vue?vue&type=style&index=0&id=879648e8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879648e8",
  null
  
)

export default component.exports